let children = [];

children.push({
    path: "/utility/CheckList",
    name: "TLT_CHECK_LIST",
    component: () =>
        import ("@/views/Utility/CheckList/CheckList.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Utilitarios", disabled: true },
            { text: "CheckList", href: "/utility/CheckList" },
        ],
    },
});

children.push({
    path: "/utility/tareas",
    name: "TLT_TASK",
    component: () =>
        import ("@/views/Utility/Task/Task.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Utilitarios", disabled: true },
            { text: "Tareas", href: "/utility/tareas" },
        ],
    },
});
children.push({
    path: "/utility/proyectos",
    name: "TLT_TASK_PROYECT",
    component: () =>
        import ("@/views/Utility/TaskProyect/TaskProyect.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Utilitarios", disabled: true },
            { text: "Proyectos", href: "/utility/proyectos" },
        ],
    },
});
export { children };